import http from "./http.js";

async function createProject(project) {
  try {
    const response = await http.post("projects", project);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getProject(id) {
  try {
    const response = await http.get(`projects/${id}`);
    return {
      title: response.data.title,
      client: response.data.client
        ? {
          id: response.data.client.id,
          title: response.data.client.title,
        }
        : null,
      fixPrice: response.data.fixPrice,
      id: response.data.id,
      category: response.data.category,
    };
  } catch (err) {
    throw err;
  }
}

async function updateProject(id, project) {
  try {
    const response = await http.put(`projects/${id}`, project);
    return response;
  } catch (err) {
    throw err;
  }
}

async function assignProjectToClient(id, { clientId, fixPrice }) {
  try {
    const response = await http.put(
      `projects/${id}/client-id/${clientId}?fixPrice=${fixPrice}`
    );
    return response;
  } catch (err) {
    throw err;
  }
}

async function getProjects(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get("projects", {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm: search,
        clientId: filter?.client?.id || "",
        category: filter?.client?.category || "",
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getProjectsWithoutClient(searchTerm = "") {
  try {
    const response = await http.get("projects/without-client", {
      params: {
        searchTerm,
      },
    });

    return response.data.map((project) => {
      return {
        id: project.id,
        title: project.title,
        fixPrice: project.fixPrice,
        key: project.key,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function selectProject(
    page = 1,
    rowsPerPage = 9,
    search = "",
    clientId = ""
) {
  try {
    const response = await http.get("projects/references", {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm: search,
        clientId,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  createProject,
  getProject,
  updateProject,
  selectProject,
  getProjects,
  getProjectsWithoutClient,
  assignProjectToClient,
};
